export const minute = 60
export const hour = 60 * minute
export const day = 24 * hour
export const week = 7 * day
export const month = 30 * day
export const year = 365 * day
